// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hWCYhVmakTW1tQUQoKyp{min-height:56px}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/reanalyze/reanalyze-card-container/reanalyze-card-container.module.scss"],"names":[],"mappings":"AACA,sBACE,eAAA","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.reanalyze_card_inner_container {\n  min-height: 56px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reanalyze_card_inner_container": `hWCYhVmakTW1tQUQoKyp`
};
export default ___CSS_LOADER_EXPORT___;
